import { Card, CardHeader, Typography } from "@mui/material";
import React from "react";
import { MdOutlinePointOfSale } from "react-icons/md";

const JPosHeader = () => {
  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h4" component="div">
            نقطة البيع
          </Typography>
        }
        avatar={<MdOutlinePointOfSale size={20} />}
      />
    </Card>
  );
};

export default JPosHeader;
